// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2r2yX","buttons":"Footer_buttons__2hg42"};